"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { navigation } from "./navigation";
import { useServer } from "@/components/providers/ServerProvider";

export default function Sidebar() {
  const pathname = usePathname();
  const { online } = useServer();

  return (
    <aside className="hidden md:flex fixed left-0 top-0 bottom-0 w-56 lg:w-64 bg-[#151719] border-r border-white/10 flex-col z-40">

      {/* Logo */}
      <div className="h-20 px-5 lg:px-6 flex items-center border-b border-white/10">

        <div>
          <p className="text-[10px] lg:text-xs text-gray-500 uppercase tracking-wider">
            Server
          </p>

          <h1 className="text-lg lg:text-xl font-semibold">
            My Server
          </h1>
        </div>

        <div
          className={`ml-auto h-2.5 w-2.5 rounded-full ${
            online
              ? "bg-green-400"
              : "bg-red-400"
          }`}
        />

      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2 lg:px-3 py-5 overflow-y-auto">

        {navigation.map((group) => (
          <div
            key={group.section}
            className="mb-7"
          >

            <p className="px-3 mb-2 text-[10px] lg:text-xs font-medium text-gray-500">
              {group.section}
            </p>

            <div className="space-y-1">

              {group.items.map((item) => {

                const active =
                  pathname === item.href;

                return (
                  <Link
                    key={item.href}
                    href={item.href}
                    className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition ${
                      active
                        ? "bg-white/10 text-white"
                        : "text-gray-400 hover:bg-white/5 hover:text-white"
                    }`}
                  >

                    <span className="text-lg w-6 text-center shrink-0">
                      {item.icon}
                    </span>

                    <span className="truncate">
                      {item.label}
                    </span>

                    {item.href === "/server/minecraft" && (
                      <span
                        className={`ml-auto h-2 w-2 rounded-full shrink-0 ${
                          online
                            ? "bg-green-400"
                            : "bg-red-400"
                        }`}
                      />
                    )}

                  </Link>
                );
              })}

            </div>

          </div>
        ))}

      </nav>

      {/* Bottom */}
      <div className="border-t border-white/10 p-2 lg:p-3">

        <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-gray-400 hover:bg-white/5 hover:text-white transition">

          <span className="text-lg w-6 text-center">
            ⚙️
          </span>

          <span>
            Settings
          </span>

        </button>

        <div className="mt-3 px-3 py-3 rounded-lg bg-[#202328]">

          <p className="text-[10px] lg:text-xs text-gray-500">
            SERVER STATUS
          </p>

          <div className="flex items-center gap-2 mt-2">

            <span
              className={`h-2 w-2 rounded-full ${
                online
                  ? "bg-green-400"
                  : "bg-red-400"
              }`}
            />

            <span className="text-sm">
              {online ? "Online" : "Offline"}
            </span>

          </div>

        </div>

      </div>

    </aside>
  );
}